import throttle from 'lodash/throttle'

const checkViewport = {
  data () {
    return {
      animationFrameLock: false,
      inViewport: false,
      scrolledBehind: false,
      elBoundingRect: null,
      scrolledToBottom: false,
      viewportScrollHandler: throttle(this.updateBoundClientRect, 100)
    }
  },
  methods: {
    updateBoundClientRect () {
      if (!this.$el || !this.$el.getBoundingClientRect) {
        return
      }
      const rect = this.$el.getBoundingClientRect()
      this.inViewport = (
        rect.top >= 0 &&
        rect.bottom <= window.innerHeight
      )
      this.inParallaxRange = (
        rect.top >= -1200 &&
        rect.bottom <= window.innerHeight + 1200
      )
      this.scrolledBehind = rect.top <= (window.innerHeight / 100) * 80
      this.elBoundingRect = rect
      this.scrolledToBottom = (window.innerHeight + window.scrollY) >= document.body.offsetHeight
      this.animationFrameLock = false
    },
    onScroll () {
      if (this.animationFrameLock) { return }
      this.animationFrameLock = true
      requestAnimationFrame(this.updateBoundClientRect)
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.viewportScrollHandler)
  },
  mounted () {
    if (process.server) { return }
    this.updateBoundClientRect()
    window.addEventListener('scroll', this.viewportScrollHandler)
  }
}

export default checkViewport
